import type { PropsWithChildren } from 'react';

import { HStack, VStack } from '@frontend/legacy-components';

import { PageTitle } from 'components/PageTitle';

import ConfigurePageNavTabs from '../configurePageNavTabs/ConfigurePageNavTabs';
import ConfigItemListPageWrapper from './ConfigItemListPageWrapper';
import type { ConfigItemListPageWrapperProps } from './ConfigItemListPageWrapper';

export interface ConfigItemListPageProps extends PropsWithChildren<unknown> {
  pageTitle: string;
  wrapperProps?: ConfigItemListPageWrapperProps;
  constrainWidth?: boolean;
}

const ConfigItemListPage = ({
  pageTitle,
  children,
  constrainWidth = true,
  wrapperProps = {},
}: ConfigItemListPageProps) => {
  return (
    <ConfigItemListPageWrapper {...wrapperProps}>
      <PageTitle title={pageTitle} />
      <HStack
        as="main"
        alignItems="stretch"
        minHeight="100%"
        gap={3.5}
        maxWidth={constrainWidth ? '1200px' : undefined}
        spacing={0}
        mx="auto"
      >
        <ConfigurePageNavTabs />
        <VStack
          alignItems="stretch"
          flex="1 1 100%"
          spacing={2}
          position="relative"
          py={4}
          px={1}
        >
          {children}
        </VStack>
      </HStack>
    </ConfigItemListPageWrapper>
  );
};

export default ConfigItemListPage;
